import { Module, Action, getModule, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '@/store'
import * as DateUtil from '@/tcw/utils/DateUtil'

/**
 * メッセージSTORE
 */
@Module({
  name: 'BasicStoreModule',
  store,
  namespaced: true,
  dynamic: true
})
export default class BasicStoreModule extends VuexModule {
  private currentDate: Date = DateUtil.now()
  private hasUpdateLocal = false
  private appUpdateConfirmDialogLocal = false
  private kintaiCheckModeFlg = false
  private debugFlg = false

  /****************
   * Mutation
   ****************/
  @Mutation
  private setCurrentDate(date: Date) {
    this.currentDate = date
  }
  @Mutation
  private setHasUpdate(val: boolean) {
    this.hasUpdateLocal = val
  }
  @Mutation
  private setAppUpdateConfirmDialogLocal(val: boolean) {
    this.appUpdateConfirmDialogLocal = val
  }
  @Mutation
  private setKintaiCheckModeFlg(val: boolean) {
    this.kintaiCheckModeFlg = val
  }
  @Mutation
  private setDebugFlg(val: boolean) {
    this.debugFlg = val
  }

  /****************
   * Getter
   ****************/
  public get targetDate(): Date {
    return this.currentDate
  }
  public get hasUpdate(): boolean {
    return this.hasUpdateLocal
  }
  public get appUpdateConfirmDialog(): boolean {
    return this.appUpdateConfirmDialogLocal
  }
  public get isKintaiCheckMode(): boolean {
    return this.kintaiCheckModeFlg
  }
  public get isDebug(): boolean {
    return this.debugFlg
  }

  /****************
   * Action
   ****************/
  @Action({ rawError: true })
  public setTargetDate(date: Date): void {
    this.setCurrentDate(date)
  }
  /**
   */
  @Action({ rawError: true })
  public nextDate(): void {
    const newDate = DateUtil.addDate(this.currentDate, 1, 'd')
    this.setCurrentDate(newDate)
  }
  /**
   */
  @Action({ rawError: true })
  public prevDate(): void {
    const newDate = DateUtil.addDate(this.currentDate, -1, 'd')
    this.setCurrentDate(newDate)
  }
  /**
   */
  @Action({ rawError: true })
  public nextMonth(): void {
    const newDate = DateUtil.addDate(this.currentDate, 1, 'M')
    this.setCurrentDate(newDate)
  }
  /**
   */
  @Action({ rawError: true })
  public prevMonth(): void {
    const newDate = DateUtil.addDate(this.currentDate, -1, 'M')
    this.setCurrentDate(newDate)
  }
  /**
   */
  @Action({ rawError: true })
  public nextYear(): void {
    const newDate = DateUtil.addDate(this.currentDate, 1, 'y')
    this.setCurrentDate(newDate)
  }
  /**
   */
  @Action({ rawError: true })
  public prevYear(): void {
    const newDate = DateUtil.addDate(this.currentDate, -1, 'y')
    this.setCurrentDate(newDate)
  }
  /**
   */
  @Action({ rawError: true })
  public clearCurrentDate(): void {
    this.setCurrentDate(DateUtil.now())
  }
  @Action({ rawError: true })
  public setUpdateState(state: boolean): void {
    this.setHasUpdate(state)
    this.setAppUpdateConfirmDialogLocal(state)
  }
  @Action({ rawError: true })
  public setAppUpdateConfirmDialog(state: boolean): void {
    this.setAppUpdateConfirmDialogLocal(state)
  }
  @Action({ rawError: true })
  public setKintaiCheckMode(state: boolean): void {
    this.setKintaiCheckModeFlg(state)
  }
  @Action({ rawError: true })
  public changeDebugFlg(): void {
    this.setDebugFlg(!this.debugFlg)
  }
}

export const basicStore = getModule(BasicStoreModule)
